/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import { Link } from "react-router-dom";
import { qreq } from "../../shared/qrequest";
import L from "../Lang"
import BaseCom from "../BaseCom";
import Icon from "../Icon";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import Auth from "../../shared/Auth";
import AppActions from "../AppActions";

class ChatChannelInfo extends BaseCom {

    componentDidMount() {
        qreq.get('/api/chat/channel/get/' + this.props.params.id, j => {
            if (j.item) {
                this.setState({ info: j.item });
            }
            else
                this.alert(j.errorMessage);
        }, this.unkownErrorCallback);
    }


    render() {
        return <div className="container-fluid">
            <AppActions />
            <h1>{this.state.info?.name}</h1>
            <p>{this.state.info?.description}</p>
            <h4>Members {Auth.hasRole('admin') && <Link to={`/chat/${this.state.info?.id}/edit`} role="button" className="btn btn-secondary"><L>edit</L></Link>}</h4>
            <ul className="list-group">
                {this.state.info?.members?.map(m => <li key={m.id} className="list-group-item"><Icon icon="faUser" /> {m.userName}</li>)}
            </ul>
        </div>;
    }
}

export default withParamsAndNavigate(ChatChannelInfo);